module.exports = __webpack_public_path__ + "img/23.02d0d534.jpg";